var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkles = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.316 16.684 4 15l6.316-1.684L12 7l1.684 6.316L20 15l-6.316 1.684L12 23l-1.684-6.316ZM22.763 4.237 20 3.5l2.763-.737L23.5 0l.737 2.763L27 3.5l-2.763.737L23.5 7l-.737-2.763ZM18.974 25.026 17 24.5l1.974-.526L19.5 22l.526 1.974L22 24.5l-1.974.526L19.5 27l-.526-1.974ZM1.974 8.026 0 7.5l1.974-.526L2.5 5l.526 1.974L5 7.5l-1.974.526L2.5 10l-.526-1.974Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkles);
export default ForwardRef;